<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <div class="form-group--inside">
          <h4>LLM Prompt</h4>

          <div class="description">Here, you can set the persona for your LLM to control how it behaves and responds.</div>

          <h4 class="mt">
            Persona & General Instructions
            <Tooltip title="This is your general instructions for the LLM. This is used to control how it behaves and responds." />
          </h4>
          <div class="form-group--inside">
            <Autocomplete :items="variables" name="persona" id="persona" v-model="persona" :rows="15" placeholder="Enter the bot's persona description" />
          </div>

          <div v-if="advance">
            <h4 class="mt">Retriever Query</h4>
            <div class="form-group--inside">
              <Autocomplete
                :items="variables"
                name="additionalQuery"
                id="additionalQuery"
                v-model="additionalQuery"
                :rows="5"
                placeholder="Enter additional query instructions for the bot"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { LLMObject } from '../../../../../../common/types/llm-type'
import Autocomplete from '@/components/helpers/Autocomplete.vue'
import Dropdown from '@/components/helpers/Dropdown.vue'
import Toggle from '@/components/helpers/Toggle.vue'
import Tooltip from '@/components/helpers/Tooltip.vue'

@Component({ components: { Autocomplete, Dropdown, Toggle, Tooltip } })
export default class LLMContext extends Vue {
  @Prop() LLM: LLMObject
  @Prop() variables: string[]

  advance = false

  get persona() {
    return this.LLM.persona
  }

  set persona(value: string) {
    this.LLM.persona = value
  }

  get additionalQuery() {
    return this.LLM.additionalLLMQuery
  }

  set additionalQuery(value: string) {
    this.LLM.additionalLLMQuery = value
  }
}
</script>

<style scoped lang="scss">
@import '../../../../assets/scss/variables';

.description {
  font-size: 14px;
  margin-bottom: 15px;
}

.mt {
  margin-top: 20px;
}

.dot-wrapper {
  display: flex;
  margin: 0px 0px -15px 0px;
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;

    &.red {
      background-color: $red;
    }

    &.green {
      background-color: $green;
    }
  }
  .description {
    margin-left: 10px;
    margin-top: -5px;
  }
}
</style>
